import { render } from "./ChooseStore.vue?vue&type=template&id=ad8a8c56&scoped=true"
import script from "./ChooseStore.vue?vue&type=script&lang=js"
export * from "./ChooseStore.vue?vue&type=script&lang=js"

import "./ChooseStore.vue?vue&type=style&index=0&id=ad8a8c56&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad8a8c56"]])

export default __exports__